const FORM_SUBMIT_EVENT_GTM = ["Affiliate_form", "clicked", "Affiliate_signup_CTA"];
const FORM_SUBMIT_EVENT_MP = "website_landing_page_affiliate:Affiliate_signup_CTA";

const typeOfReferrerOptions = [
  { value: "Bank / Finance Portal", label: "Bank / Finance Portal" },
  { value: "Car rental / Parking / Taxi", label: "Car rental / Parking / Taxi" },
  { value: "Cashbacker / Coupon portal", label: "Cashbacker / Coupon portal" },
  { value: "Comparison portal", label: "Comparison portal" },
  { value: "Flight compensation", label: "Flight compensation" },
  { value: "Flight tracker", label: "Flight tracker" },
  { value: "Influencer Finance", label: "Influencer Finance" },
  { value: "Influencer lifestyle / sport / food", label: "Influencer lifestyle / sport / food" },
  { value: "Influencer Travel", label: "Influencer Travel" },
  { value: "Insurance", label: "Insurance" },
  { value: "Lead generator / Network", label: "Lead generator / Network" },
  { value: "Legal", label: "Legal" },
  { value: "Newspaper / Media", label: "Newspaper / Media" },
  { value: "Travel Service", label: "Travel Service" },
  { value: "Others", label: "Others" },
];

const mainPromotionRouteOptions = [
  { value: "Website", label: "Website" },
  { value: "App", label: "App" },
  { value: "Blogpost", label: "Blogpost" },
  { value: "Medium", label: "Medium" },
  { value: "Pinterest", label: "Pinterest" },
  { value: "Email", label: "Email" },
  { value: "Facebook", label: "Facebook" },
  { value: "Instagram", label: "Instagram" },
  { value: "Twitter", label: "Twitter" },
  { value: "Telegram", label: "Telegram" },
  { value: "VK", label: "VK" },
  { value: "Pop-Up", label: "Pop-Up" },
  { value: "YouTube", label: "YouTube" },
  { value: "Offline", label: "Offline" },
  { value: "Others", label: "Others" },
];

const monthlyTrafficEstimationOptions = [
  { value: "N/A", label: "N/A" },
  { value: "1.000 - 10.000", label: "1.000 - 10.000" },
  { value: "10.000 - 50.000", label: "10.000 - 50.000" },
  { value: "50.000 - 100.000", label: "50.000 - 100.000" },
  { value: "100.000 - 250.000", label: "100.000 - 250.000" },
  { value: "250.000 - 500.000", label: "250.000 - 500.000" },
  { value: "500.000 -1.000.000", label: "500.000 -1.000.000" },
  { value: "1.000.000 - 2.000.000", label: "1.000.000 - 2.000.000" },
  { value: "2.000.000 - 5.000.000", label: "2.000.000 - 5.000.000" },
  { value: "5.000.000 - 10.000.000", label: "5.000.000 - 10.000.000" },
  { value: "> 10.000.000", label: "> 10.000.000" },
];

const mainPromotionalLanguageOptions = [
  { value: "English International (EN-INT)", label: "English International (EN-INT)" },
  { value: "English (UK)", label: "English (UK)" },
  { value: "English (US/CA)", label: "English (US/CA)" },
  { value: "اَلْعَرَبِيَّةُ (AR)", label: "اَلْعَرَبِيَّةُ (AR)" },
  { value: "český (CS)", label: "český (CS)" },
  { value: "Dansk (DA)", label: "Dansk (DA)" },
  { value: "Deutsch (DE)", label: "Deutsch (DE)" },
  { value: "Eλληνικα (EL)", label: "Eλληνικα (EL)" },
  { value: "Español (ES)", label: "Español (ES)" },
  { value: "Español (ES-LA)", label: "Español (ES-LA)" },
  { value: "Suomi (FI)", label: "Suomi (FI)" },
  { value: "Français (FR)", label: "Français (FR)" },
  { value: "עברית (HE)", label: "עברית (HE)" },
  { value: "Hrvatski (HR)", label: "Hrvatski (HR)" },
  { value: "Magyar (HU)", label: "Magyar (HU)" },
  { value: "Italiano (IT)", label: "Italiano (IT)" },
  { value: "Lietuvių (LT)", label: "Lietuvių (LT)" },
  { value: "Latviešu (LV)", label: "Latviešu (LV)" },
  { value: "Norsk (NB)", label: "Norsk (NB)" },
  { value: "Nederlands (NL)", label: "Nederlands (NL)" },
  { value: "Polski (PL)", label: "Polski (PL)" },
  { value: "Português Brasil (PT-BR)", label: "Português Brasil (PT-BR)" },
  { value: "Português Portugal (PT-PT)", label: "Português Portugal (PT-PT)" },
  { value: "Română (RO)", label: "Română (RO)" },
  { value: "Pусский (RU)", label: "Pусский (RU)" },
  { value: "Slovenščina (SI)", label: "Slovenščina (SI)" },
  { value: "Slovenský (SK)", label: "Slovenský (SK)" },
  { value: "Shqip (SQ)", label: "Shqip (SQ)" },
  { value: "Svenska (SV)", label: "Svenska (SV)" },
  { value: "Türkçe (TR)", label: "Türkçe (TR)" },
  { value: "українська (UKR)", label: "українська (UKR)" },
  { value: "OTHER", label: "OTHER" },
];

export {
  typeOfReferrerOptions,
  mainPromotionRouteOptions,
  monthlyTrafficEstimationOptions,
  mainPromotionalLanguageOptions,
  FORM_SUBMIT_EVENT_GTM,
  FORM_SUBMIT_EVENT_MP,
};
